import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BulbOutlined } from "@ant-design/icons";
import { Alert, Checkbox, Form, Input } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { SupportFormNestedFieldsContainer } from "./nestedFieldsContainer.js";
import { useSupportFormProductType } from "../../hooks/useSupportFormProductType.js";
import { __, _i } from "../../utils/i18n.js";
const SupportFormLicenseField = (param)=>{
    let { customerCenter } = param;
    const productTypes = useSupportFormProductType();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, curValues)=>prevValues.product !== curValues.product || prevValues.questionType !== curValues.questionType,
        children: (param)=>{
            let { getFieldValue } = param;
            const questionType = getFieldValue("questionType");
            const product = getFieldValue("product");
            if (!product || questionType === ESupportTicketQuestionType.RequestCustomOffer) {
                return null;
            }
            const { licenseHelpArticle, ecommercePlatform } = productTypes[product];
            if (!ecommercePlatform) {
                return null;
            }
            return /*#__PURE__*/ _jsxs(SupportFormNestedFieldsContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "bought",
                        valuePropName: "checked",
                        label: __("Have you already bought the product?"),
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            children: __("Yes, I already bought the above product.")
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        shouldUpdate: (prevValues, curValues)=>prevValues.bought !== curValues.bought,
                        children: (param)=>{
                            let { getFieldValue } = param;
                            return getFieldValue("bought") && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        name: "licenseKey",
                                        label: ecommercePlatform === "envato" ? `${__("License key")} / ${__("Purchase code")}` : __("License key"),
                                        required: true,
                                        extra: _i(__("Read this {{a}}help article{{/a}} to learn how to obtain your license key."), {
                                            a: /*#__PURE__*/ _jsx("a", {
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                href: licenseHelpArticle
                                            })
                                        }),
                                        rules: [
                                            {
                                                required: true,
                                                message: __("Please insert your license key!")
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsx(Input, {})
                                    }),
                                    customerCenter && /*#__PURE__*/ _jsx(Alert, {
                                        icon: /*#__PURE__*/ _jsx(BulbOutlined, {}),
                                        showIcon: true,
                                        style: {
                                            marginBottom: 15
                                        },
                                        message: _i(__("{{strong}}Customer center:{{/strong}} When you {{a}}sign in to your account{{/a}}, you can view and manage all your subscriptions, purchases, and invoices. You can also upgrade your subscriptions and generate additional license keys for active subscriptions, delete them, or detach them from active installations."), {
                                            strong: /*#__PURE__*/ _jsx("strong", {}),
                                            a: /*#__PURE__*/ _jsx("a", {
                                                href: customerCenter,
                                                rel: "noreferrer",
                                                target: "_blank"
                                            })
                                        }),
                                        type: "info"
                                    })
                                ]
                            });
                        }
                    })
                ]
            });
        }
    });
};
export { SupportFormLicenseField };
